import * as Realm from 'realm-web';

const app = new Realm.App({ id: "romp-pbqof" })

export default app;